import React, { Component } from "react";

export default class ImgVdoAnalytics extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="104" height="109" fill="none" viewBox="0 0 104 109">
                <path fill="#FF7C7D" d="M.654 41.957c0 22.968 18.619 41.588 41.587 41.588 22.968 0 41.587-18.62 41.587-41.588S65.208.37 42.241.37C19.273.37.654 18.99.654 41.957z" />
                <circle cx="42.068" cy="41.825" r="30.686" fill="#fff" transform="rotate(-180 42.068 41.825)" />
                <path stroke="#FF2828" stroke-miterlimit="10" strokeWidth="1.2" d="M36.774 49.622l-2.782-1.606v3.212l2.782-1.606zm0 0l-2.782-1.606v3.212l2.782-1.606z" />
                <path stroke="#FF2828" stroke-miterlimit="10" strokeWidth="1.6" d="M26.835 55.758v-12.27h16.432v12.27H26.835zM33.769 39.113V25.455h23.367v13.658H33.769z" />
                <path stroke="#FF2828" stroke-miterlimit="10" strokeWidth="1.6" d="M41.835 31.868c.849 0 1.538-.689 1.538-1.538 0-.85-.689-1.538-1.538-1.538-.85 0-1.538.688-1.538 1.538 0 .85.688 1.538 1.538 1.538zM33.793 39.124l5.09-4.872 3.563 3.41 5.345-5.116 3.308 3.167 6.109-5.847" />
            </svg>
        );
    }
}
